import styled from '@emotion/styled';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { T, useTranslate } from '@tolgee/react';

const enterprisePrices: Partial<
  Record<
    General.Currency,
    {
      total: string;
      account: string;
      service: string;
    }
  >
> = {
  CNY: {
    total: '¥36,000',
    account: '¥550',
    service: '¥3,000',
  },
  USD: {
    total: '$5,200',
    account: '$80',
    service: '$500',
  },
};

export interface EnterpriseTotalProps {
  currency: General.Currency;
}

export const EnterpriseTotal = (props: EnterpriseTotalProps) => {
  const { currency } = props;
  const { payQrcode } = useFlagConfigValue();
  const { t } = useTranslate();

  return (
    <EnterpriseContainer>
      <div>
        <T
          keyName="market.起年"
          params={{
            comx: <b />,
            num: enterprisePrices?.[currency]?.total,
          }}
        />
      </div>
      <div>
        <div>
          {t('market.高级客服帐号月', {
            num: enterprisePrices?.[currency]?.account,
          })}
        </div>
        <div>
          {t('market.定制化配置服务费', {
            num: enterprisePrices?.[currency]?.service,
          })}
        </div>
      </div>
      <img src={payQrcode} alt="Pay" />
      <strong>{t('market.咨询更多企业版服务详情，扫码添加客户服务专家')}</strong>
    </EnterpriseContainer>
  );
};

const EnterpriseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 0;
  background: var(--fett-erp-card-bg);
  color: var(--fett-text-secondary);
  text-align: center;

  b {
    font-weight: 500;
    font-size: 32px;
    color: #ee4e2d;
    padding: 0 4px;
  }

  & > img {
    width: 160px;
    height: 160px;
  }
`;
